import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import { api } from "@/lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("admin@cabinet-gpi.fr");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("gpi_admin_token", data.access_token);
      toast.success("Bienvenue.");
      navigate("/admin/articles");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Identifiants invalides");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F9F8F6] flex items-center justify-center p-4" data-testid="page-admin-login">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <div className="inline-flex w-12 h-12 border border-[#0F172A] items-center justify-center">
            <Lock size={18} className="text-[#0F172A]" />
          </div>
          <h1 className="font-serif text-3xl text-[#0F172A] mt-6">Espace administrateur</h1>
          <p className="text-[#64748B] mt-2 text-sm">Cabinet GPI · Back-office</p>
        </div>

        <form onSubmit={submit} className="bg-white border border-[#E2E8F0] p-8 space-y-5">
          <label className="block">
            <span className="block text-xs font-medium text-[#64748B] uppercase tracking-wider mb-2">
              Email
            </span>
            <input
              type="email"
              data-testid="admin-login-email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full px-4 py-3 border border-[#E2E8F0] bg-[#F9F8F6] focus:border-[#0F172A] focus:bg-white outline-none transition-colors"
            />
          </label>
          <label className="block">
            <span className="block text-xs font-medium text-[#64748B] uppercase tracking-wider mb-2">
              Mot de passe
            </span>
            <input
              type="password"
              data-testid="admin-login-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full px-4 py-3 border border-[#E2E8F0] bg-[#F9F8F6] focus:border-[#0F172A] focus:bg-white outline-none transition-colors"
            />
          </label>
          <button
            type="submit"
            data-testid="admin-login-submit"
            disabled={loading}
            className="gpi-btn-primary w-full justify-center disabled:opacity-60"
          >
            {loading ? "Connexion..." : "Se connecter"}
          </button>
        </form>
      </div>
    </div>
  );
}
